var Unicode = {
  getBytes: function (text) {
    return text.split("").reduce(function (codepoints, char) {
      var code = char.charCodeAt(0);
      codepoints.push(code & 0xff, code >> 8);
      return codepoints;
    }, []);
  },
  getCodePoints: function (bytes) {
    var i = 0;
    var codepoints = [];
    while (i + 1 < bytes.length) {
      codepoints.push((bytes[i + 1] << 8) + bytes[i]);
      i = i + 2;
    }

    return codepoints;
  },
};
var Ascii = {
  getString: function (bytes) {
    var i = 0;
    var str = "";
    while (i + 1 < bytes.length) {
      str += String.fromCodePoint(bytes[i], bytes[i + 1]);
      i = i + 2;
    }
    return str;
  },
};

function wrap(guid) {
  if (guid.length === 43) {
    // eslint-disable-next-line no-useless-escape
    var normalized = guid.replace(/\-/g, "+").replace(/\_/g, "/") + "=";
    var decoded = window.atob(normalized);

    return {
      Base64Guid: guid,
      Regular: String.fromCodePoint.apply(
        null,
        Unicode.getCodePoints(
          decoded.split("").map(function (c) {
            return c.charCodeAt(0);
          })
        )
      ),
      __type:
        "OdinSystemer.FixitOnline.OdinArchitectureCore.BusinessBase.OdinGuid",
    };
  }
  if (guid.length === 16) {
    return {
      // eslint-disable-next-line no-useless-escape
      Base64Guid: window
        .btoa(Ascii.getString(Unicode.getBytes(guid)))
        .replace(/\=/g, "")
        .replace(/\+/g, "-")
        .replace(/\//g, "_"),
      Regular: guid,
      __type:
        "OdinSystemer.FixitOnline.OdinArchitectureCore.BusinessBase.OdinGuid",
    };
  }

  // console.warn('wrapOdinGuid called on non-compliant object: ' + guid)
  return {
    Base64Guid: "",
    Regular: "",
    __invalid_param: guid,
    __type:
      "OdinSystemer.FixitOnline.OdinArchitectureCore.BusinessBase.OdinGuid",
  };
}

function wrapOdinGuid(object, propertyname) {
  let odinProductId = parseInt(object);
  if (odinProductId) return odinProductId.toString();
  if (typeof object === "string") {
    return wrap(object);
  }
  if (typeof object === "object") {
    var prop = object[propertyname];
    if (typeof prop === "string") {
      object[propertyname] = wrap(prop);
    }
  }
}

window.wrapOdinGuid = wrapOdinGuid;
export default wrapOdinGuid;
